import React from 'react';

const styles = {
  container: {
    marginBottom: '30px',
  },
  phaseSection: {
    marginBottom: '25px',
  },
  phaseHeader: {
    fontSize: '14px',
    fontWeight: '600',
    marginBottom: '12px',
    color: '#333333',
    fontFamily: 'Poppins, sans-serif',
  },
  table: {
    width: '100%',
    borderCollapse: 'collapse',
    fontFamily: 'Poppins, sans-serif',
  },
  tableHeader: {
    backgroundColor: '#f5f5f5',
    borderBottom: '1px solid #e0e0e0',
  },
  headerCell: {
    fontSize: '10px',
    fontWeight: '600',
    color: '#444444',
    padding: '8px 6px',
    textAlign: 'left',
    borderRight: '1px solid #f0f0f0',
  },
  tableRow: {
    borderBottom: '1px solid #f0f0f0',
  },
  tableCell: {
    fontSize: '9px',
    color: '#333333',
    padding: '6px',
    borderRight: '1px solid #f0f0f0',
    fontFamily: 'Poppins, sans-serif',
  },
  abilityCell: {
    fontSize: '9px',
    color: '#333333',
    fontWeight: '500',
    fontFamily: 'Poppins, sans-serif',
  },
  categoryCell: {
    fontSize: '9px',
    textTransform: 'capitalize',
    fontFamily: 'Poppins, sans-serif',
  },
  countCell: {
    textAlign: 'center',
    fontWeight: '500',
  },
  percentageCell: {
    textAlign: 'center',
    fontWeight: '500',
  },
  emptyMessage: {
    fontSize: '10px',
    color: '#888888',
    fontStyle: 'italic',
    fontFamily: 'Poppins, sans-serif',
    textAlign: 'center',
    padding: '15px',
  }
};

// Category colors matching the cinema map
const categoryColors = {
  skills: '#4CAF50',
  knowledge: '#2196F3',
  mindset: '#FF9800',
  instruments: '#9C27B0',
};

const TopCompetenciesTable = ({ topCompetenciesData, totalParticipants }) => {
  const phases = ['Empathize', 'Define', 'Ideate', 'Prototype', 'Test', 'Communicate'];

  if (!topCompetenciesData || !totalParticipants) {
    return (
      <div style={styles.container}>
        <div style={styles.emptyMessage}>
          No competency data available
        </div>
      </div>
    );
  }

  return (
    <div style={styles.container}>
      {phases.map(phase => {
        const phaseData = topCompetenciesData[phase] || [];
        
        return (
          <div key={phase} style={styles.phaseSection}>
            <div style={styles.phaseHeader}>{phase}</div>
            
            {phaseData.length > 0 ? (
              <table style={styles.table}>
                <thead style={styles.tableHeader}>
                  <tr>
                    <th style={{...styles.headerCell, width: '25%'}}>Ability Name</th>
                    <th style={{...styles.headerCell, width: '35%'}}>Competency Name</th>
                    <th style={{...styles.headerCell, width: '15%'}}>Category</th>
                    <th style={{...styles.headerCell, width: '12%'}}>Times Selected</th>
                    <th style={{...styles.headerCell, width: '13%', borderRight: 'none'}}>% of Participants</th>
                  </tr>
                </thead>
                <tbody>
                  {phaseData.map((item, index) => {
                    const categoryColor = categoryColors[item.category] || '#666666';
                    
                    return (
                      <tr key={`${item.competencyId}-${index}`} style={styles.tableRow}>
                        <td style={{...styles.tableCell, ...styles.abilityCell}}>
                          {item.abilityName}
                        </td>
                        <td style={styles.tableCell}>
                          {item.competencyName}
                        </td>
                        <td style={{
                          ...styles.tableCell, 
                          ...styles.categoryCell,
                          color: categoryColor
                        }}>
                          {item.category}
                        </td>
                        <td style={{...styles.tableCell, ...styles.countCell}}>
                          {item.count}
                        </td>
                        <td style={{
                          ...styles.tableCell, 
                          ...styles.percentageCell,
                          borderRight: 'none'
                        }}>
                          {item.percentage}%
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            ) : (
              <div style={styles.emptyMessage}>
                No competencies selected for this phase
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default TopCompetenciesTable;
